module.exports = __webpack_public_path__ + "static/images/list-banner2.a5130b0.png";